export const BASE_CONST = {
  tableTitles: [
    {
      label: "1.1 Stationary Combustion",
      titles: [
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      ////////用來跟回傳資料mapping的
      dataKey: ["name", "itemName", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Direct emissions from stationary combustion are the consequence of the combustion of any type of fuel (fossil or biomass) burned in stationary (fixed) equipment, such as heaters, gas turbines, and boilers. This could be done to generate heat, mechanical work, and steam.",
    },
    {
      label: "1.2 Mobile Combustion",
      titles: [
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "Computation Method",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "name",
        "itemName",
        "computationMethod",
        "sourceEFName",
        "emissionFactorName",
      ],
      tooltip:
        "Direct emissions from mobile combustion are the consequence of fuel burned in transport equipment such as motor vehicles, trucks, ships, aircraft, locomotives, and forklift trucks. Emissions from journeys in vehicles not included within the organizational boundaries should be reported as 'indirect emissions' arising from business travel, employee commuting, client or visitor transport, upstream leased assets, etc.",
    },
    {
      label: "1.3 Industrial Processes",
      titles: [
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Feedstock / Process / Emission Stream",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "Emission Factor Source",
        "Emission Factor Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["name", "itemName", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Examples of industrial processes that result in direct process emissions include, but are not limited to, cement and lime production, chemical production, manufacturing, oil and gas refining, and non-combustion processes involving the avoidance, replacement, destruction, decomposition, or mitigation of industrial GHG emissions (e.g., N₂O) and purification processes associated with carbon capture and storage (e.g., amine solution capture systems).",
    },
    {
      label: "1.4 Fugitive Emissions",
      titles: [
        "Entity Name",
        "Device Type",
        "Activity Name",
        "Name / Number",
        "Calculation Method",
        "Fugitive Emission Rate / % by mass",
        "EF Database Source",
        "Emission Gas Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Emission Gas Type",
        "GHG Emission Factor",
        "GWP",
        "Biomass",
      ],
      dataKey: [
        "equipmentCategory",
        "name",
        "itemName",
        "methodOfCalculation",
        "fugitiveEmissionsOrValue",
        "sourceEFName",
        "emissionFactorName",
      ],
      tooltip:
        "Direct fugitive emissions can come from systems that extract, process, store, and deliver fossil fuels (e.g., flanges, valves, unions, and threaded connections); from equipment leaks (e.g., cooling systems); from agricultural processes (e.g., putrefaction and fermentation, manure, livestock, application of nitrogen fertilizers); and from the uncontrolled decomposition of waste material from such sources as landfills, composting facilities, waste water treatment, and other waste management processes. Emissions from flaring or venting are quantified as 'direct emissions'. Emissions from flaring and venting could be unintentional or intentional. Examples include: designed releases of CH₄ or CO₂ containing natural gas or hydrocarbon gas (not including stationary combustion flue gas) to the atmosphere through seals or vent pipes; equipment blowdown for maintenance; and direct venting of gas used to power equipment (such as pneumatic devices). NOTE 4 Intentional reversals of carbon removals, such as backburning to prevent future forest fires, are quantified as anthropogenic biogenic emissions (negative removal) and reported in accordance with Annex D.",
    },
    {
      label: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
      titles: [
        "Entity Name",
        "Name / Number",
        "EF Database Source",
        "Ecosystem Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Ecosystem Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Direct emissions and removals from land use, land use change, and forestry (LULUCF), which covers all GHGs, from living biomass to organic matter in soils, According to IPCC guidelines [15], emissions can be assessed in six main land-use categories (forest land, cropland, grassland, wetland, settlement, and other land) and several carbon reservoirs (living above-ground biomass, living underground biomass, deadwood, leaf litter, and soil organic matter). A change in carbon stock can occur when land use changes from one category to another (e.g., converting forest to crop land) or within a land use category (e.g., converting a natural forest to a managed forest, converting from till to no-till). Removals occur when there is an increase in carbon stock in the reservoirs. Emissions occur when there is a decrease and when N₂O is emitted. Options for quantification methodologies: CO₂e emissions associated with LULUCF occur after actions have been undertaken that generate differences in carbon stocks. The period of time after this action is generally set at 20 years. Thus, organizations may quantify either all emissions associated with the action (total carbon stock differences) or annual emissions (1/20 of total carbon stock differences). If the second option is chosen, emissions should be reported 'each time' during a 20-year period. With respect to GHG emissions and removals connected to marine areas, only very limited information is available.",
    },
    {
      label: "2.1 Imported Electricity",
      titles: [
        "Entity Name",
        "Energy Supplier or Region",
        "Energy Type",
        "EF Database Source",
        "State / City / Year",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "State / City / Year",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName", "name", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Indirect emissions from imported electricity, including GHG emissions related to the production and consumption of electricity imported by the organization.",
    },
    {
      label: "2.2 Imported Energy",
      titles: [
        "Entity Name",
        "Energy Supplier or Region",
        "Energy Type",
        "EF Database Source",
        "Fuel Name / Energy Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Type / Energy Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName", "name", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Indirect emissions from imported energy, including GHG emissions related to the production of energy consumed by the organization through a physical network (steam, heating, cooling, and compressed air), excluding electricity.",
    },
    {
      label: "3.1 Upstream Transport and Distribution for Goods",
      titles: [
        "Entity Name",
        "Goods or Raw material name",
        "Vehicle Model",
        "Calculation Method",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "vehicleModel",
        "calculationName",
        "sourceEFName",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions from upstream transport and distribution of goods, which are emissions from freight services that are paid for by the organization, Options for quantification methodologies: Missions could include either the latest transport activity from the supplier to the organization or all transport activities throughout the supply chain. With respect to which option is chosen, attention should be paid to the interaction with the category for indirect GHG emissions from products used by an organization.",
    },
    {
      label: "3.2 Downstream Transport and Distribution for Goods",
      titles: [
        "Entity Name",
        "Goods or Raw material name",
        "Vehicle Model",
        "Calculation Method",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "vehicleModel",
        "calculationName",
        "sourceEFName",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions from downstream transport and distribution of goods are emissions from freight services that are due to the first purchasers or other purchasers throughout the supply chain but are not paid for by the organization. As for upstream transport and distribution of goods, the same options for quantification methodologies apply.",
    },
    {
      label: "3.3 Employee Commuting",
      titles: [
        "Entity Name",
        "Staff Name / No",
        "Transportation",
        "Calculation Method",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "name",
        "sourceEFName",
        "calculationName",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions from employee commuting, including emissions related to the transportation of employees from their homes to their workplaces, Telecommuting may incur a greater use of energy for heating or cooling than part of the employee's energy consumption at home and thus could be considered in this subcategory.",
    },
    {
      label: "3.4 Client and Visitor Transport",
      titles: [
        "Entity Name",
        "Guest Name",
        "Transportation",
        "Calculation Method",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "name",
        "calculationName",
        "sourceEFName",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions from client and visitor transport, including emissions associated with the travel of clients and visitors to the reporting company's facility.",
    },
    {
      label: "3.5 Business Travel",
      titles: [
        "Entity Name",
        "Staff Name / No",
        "Transportation",
        "Calculation Method",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Fuel Name / Vehicle Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "modeId",
        "name",
        "calculationName",
        "sourceEFName",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions from business travel are mainly due to fuel burned in mobile sources of combustion. Hotel nights might be included when linked to business travel, i.e., a stay over for flight connections, when attending a conference, or for other business purposes. The indirect emissions generated during the journey should also be included if such data are available and significant.",
    },
    {
      label: "4.1 Goods Purchased by an Organization",
      titles: [
        "Entity Name",
        "Purchased Goods Name / Model No.",
        "Raw Material Type",
        "EF Database Source",
        "Material / Product / Asset Name",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Material / Product / Asset Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName", "name", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Emissions from purchased goods, which are emissions associated with the fabrication of the product. As this could encompass a wide range of products, further subcategorization may be defined by the intended user. For example, subcategorization may distinguish products by type of materials (steel, plastic, glass, electronic, etc.) or by function in the value chain (production-related product versus non-production-related product). This subcategory includes emissions associated with the production of energy purchased by me. Nostream emissions associated with electricity production that are not otherwise included in the category for indirect GHG emissions from energy (B.3).",
    },
    {
      label:
        "4.2 Capital Goods that are Purchased and Amortized by an Organization",
      titles: [
        "Entity Name",
        "Purchased Goods Name / Model No.",
        "Product Type",
        "EF Database Source",
        "Material / Product / Asset Name",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Material / Product / Asset Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName", "name", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Emissions from capital goods are emissions from goods that are purchased and amortized by the organization. This includes goods used by the organization to manufacture a product, provide a service, or sell, store, and deliver merchandise. Generally, capital goods have an extended lifetime and are neither transformed nor sold to another organization or to consumers. This subcategory includes all stream emissions from the production of capital goods purchased or acquired by the reporting organization. Examples of capital goods include equipment, machinery, buildings, facilities, and vehicles. In financial accounting, capital equipment is treated as fixed assets, or plant, property, and equipment. Options for quantification methodologies: Emissions within this subcategory could include either the total of emissions associated with the production of the capital good or an amortized part of the total based on accounting rules or light time duration. If the second option is chosen, emissions should be reported pro-rata during the amortization period. When carbon is stored as carbon in goods for a specified time, this carbon storage should be treated according to the methodology defined in ISO 14067.",
    },
    {
      label:
        "4.3 Disposal Services (of solid or liquid waste) Used by an Organization",
      titles: [
        "Entity Name",
        "Waste Management Vendor Name",
        "Waste Disposal Method",
        "Method of Calculation",
        "EF Database Source",
        "Waste Type / Name",
        "Transportation Mode",
        "Distance",
        "Fuel Name / Vehicle Type",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Waste Type / Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "name",
        "computationMethod",
        "sourceEFName",
        "emissionFactorName",
        "activityLandName",
        "distance",
        "landEFName",
      ],
      tooltip:
        "Emissions from the disposal of solid and liquid waste depend on the characteristics of the waste and its treatment. The typical type of treatment is landfill, incineration, biological treatment, or recycling. The principal emissions are CO₂ and CH₄, and an associated emission is N₂O, which occurs in incineration or biological treatment. Options for quantification methodologies: Emissions from waste transportation (from organization to disposal facility) could be quantified either in this category or in the category for indirect GHG emissions from transportation (B.4). With respect to which option is chosen, attention should be paid to omission or double-counting issues.",
    },
    {
      label: "4.4 Use of Assets (through leased equipment) by an Organization",
      titles: ["Entity Name", "Activity Name"],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "State / City / Fuel Name / Vehicle Type",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName"],
      tooltip:
        "Emissions from the use of assets are generated through equipment leased by the reporting organization in the reporting year. This subcategory is only applicable to organizations that operate leased assets (i.e., lessees). Leases depend on the nature of the item leased, the length of the lease, and financial and contractual arrangements. Three main types of leasing could be identified: finance leasing, operating leasing, and contract hire. The organization should pay attention to ensure there is no double counting with direct emissions (e.g., vehicle fleet). An organization using the operational control method of consolidation may quantify these emissions as direct emissions.",
    },
    {
      label:
        "4.5 Use of Services not Described in the above sub-categories by an Organization",
      titles: [
        "Entity Name",
        "Activity Name",
        "EF Database Source",
        "Material / Product / Asset Name",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "Material / Product / Asset Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName", "sourceEFName", "emissionFactorName"],
      tooltip:
        "Emissions from the use of services that are not described in the above subcategories include consulting, cleaning, maintenance, mail delivery, banking, etc.",
    },
    {
      label: "5.1 Use Stage of the Product",
      titles: [
        "Entity Name",
        "Activity Name",
        "Activity Type",
        "EF Database Source",
        "Emission Source",
        "Energy Type",
        "State / City / Fuel Name / Waste Treatment Method",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "State / City / Fuel Name / Waste Treatment Method",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "name",
        "sourceEFName",
        "emissionSource",
        "energyType",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions or removals from the use stage of the product include the total expected lifetime emissions from all relevant products sold. The emissions from this subcategory are very closely linked to the life-stage scenarios. From a general point of view, the more the product is a final product, the easier it is to define scenarios. For example, it is easier for a motor vehicle manufacturer to define vehicle use scenarios (in order to evaluate motor vehicle energy consumption) than for a steel supplier, who has a wider range of application scenarios for its products.",
    },
    {
      label: "5.2 Downstream Leased Assets",
      titles: [
        "Entity Name",
        "Activity Type",
        "Activity Name",
        "EF Database Source",
        "Emission Source",
        "Energy Type",
        "State / City / Fuel Name / Waste Treatment Method",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "State / City / Fuel Name / Waste Treatment Method",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "name",
        "sourceEFName",
        "emissionSource",
        "energyType",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions from downstream leased assets include those from the operation of assets that are owned by the reporting organization and leased to other entities during the reporting year. This subcategory is applicable to lessors (i.e., organizations that receive payments from lessees).",
    },
    {
      label: "5.3 End of Life Stage of the Product",
      titles: [
        "Entity Name",
        "Waste Management Vendor Name",
        "Method of Calculation",
        "EF Database Source",
        "Emission Source",
        "Energy Type",
        "State / City / Fuel Name / Waste Treatment Method",
      ],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "EF Database Source",
        "State / City / Fuel Name / Waste Treatment Method",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: [
        "itemName",
        "calculationName",
        "sourceEFName",
        "emissionSource",
        "energyType",
        "emissionFactorName",
      ],
      tooltip:
        "Emissions from the end-of-life stage of the product include the emissions associated with the end-of-life of all products sold by the reporting organization in the reporting year. Generally, the emissions sources and sinks are those concerned with the disposal of solid and liquid waste (B.4.1). However, for the use stage of the product (B.5.1), the organization should define 'end-of-life scenarios'. Consequently, the emissions from this subcategory are closely linked to these scenarios.",
    },
    {
      label: "5.4 Investments",
      titles: ["Entity Name", "Activity Name"],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "Emission Factor Source",
        "Emission Factor Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName"],
      tooltip:
        "Emissions from investments are mainly targeting private or public financial institutions. Emissions could result from four types of operations: equity debt, investment debt, project finance, and others.",
    },
    {
      label: "6.1 Indirect GHG Emissions from other sources",
      titles: ["Entity Name", "Activity Name"],
      EFTitles: [
        "No.",
        "Entity Name",
        "Activity Name",
        "Name / Number",
        "Emission Factor Source",
        "Emission Factor Name",
        "GHG Emission Factor",
        "Biomass",
      ],
      dataKey: ["itemName"],
      tooltip:
        "The purpose of this category is to capture any organization-specific emission or removal that cannot be reported in any other category. In consequence, it is the organization's responsibility to define the content of this particular category.",
    },
    {
      label: "Emission Removal & Mitigation",
      titles: [
        "Entity",
        "Activity",
        "R&M Type",
        "Scenario",
        "Before",
        "Reduced Emission",
        "After",
        "Increased Emission",
      ],
      dataKey: [],
      tooltip:
        "GHG emission or removal differences resulting from GHG reduction initiatives.",
    },
  ],
  categoryDropdown: [
    {
      label: "Scope 1 | Category 1",
      value: "Scope 1 | Category 1",
      scope: "1",
      category: [
        {
          key: "Stationary Combustion",
          label: "1.1 Stationary Combustion",
          isDisabled: false,
        },
        {
          key: "Mobile Combustion",
          label: "1.2 Mobile Combustion",
          isDisabled: false,
        },
        {
          key: "Industrial Processes",
          label: "1.3 Industrial Processes",
          isDisabled: false,
        },
        {
          key: "Refrigerants and Fugitives",
          label: "1.4 Fugitive Emissions",
          isDisabled: false,
        },
        {
          key: "Land Use, Land Use Change and Forestry (LULUCF)",
          label: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
          isDisabled: true,
        },
      ],
    },
    {
      label: "Scope 2 | Category 2",
      value: "Scope 2 | Category 2",
      scope: "2",
      category: [
        {
          key: "Purchased Electricity",
          label: "2.1 Imported Electricity",
          isDisabled: false,
        },
        {
          key: "Imported Energy",
          label: "2.2 Imported Energy",
          isDisabled: true,
        },
      ],
    },
    {
      label: "Scope 3 | Category 3",
      value: "Scope 3 | Category 3",
      scope: "3",
      category: [
        {
          key: "Upstream T&D",
          label: "3.1 Upstream Transport and Distribution for Goods",
          isDisabled: false,
        },
        {
          key: "Downstream T&D",
          label: "3.2 Downstream Transport and Distribution for Goods",
          isDisabled: false,
        },
        {
          key: "Employee Commuting",
          label: "3.3 Employee Commuting",
          isDisabled: false,
        },
        {
          key: "Client and Visitor Transport",
          label: "3.4 Client and Visitor Transport",
          isDisabled: false,
        },
        {
          key: "Business Travel",
          label: "3.5 Business Travel",
          isDisabled: false,
        },
      ],
    },
    {
      label: "Scope 3 | Category 4",
      value: "Scope 3 | Category 4",
      scope: "3",
      category: [
        {
          key: "Purchased Goods",
          label: "4.1 Goods Purchased by an Organization",
          isDisabled: false,
        },
        {
          key: "Capital Goods that are Purchased and Amortized by an Organization",
          label:
            "4.2 Capital Goods that are Purchased and Amortized by an Organization",
          isDisabled: true,
        },
        {
          key: "Waste",
          label:
            "4.3 Disposal Services (of solid or liquid waste) Used by an Organization",
          isDisabled: false,
        },
        {
          key: "Use of Assets (through leased equipment) by an Organization",
          label:
            "4.4 Use of Assets (through leased equipment) by an Organization",
          isDisabled: true,
        },
        {
          key: "Use of Services not Described in the above sub-categories by an Organization",
          label:
            "4.5 Use of Services not Described in the above sub-categories by an Organization",
          isDisabled: true,
        },
      ],
    },
    {
      label: "Scope 3 | Category 5",
      value: "Scope 3 | Category 5",
      scope: "3",
      category: [
        {
          key: "Use Stage of the Product",
          label: "5.1 Use Stage of the Product",
          isDisabled: true,
        },
        {
          key: "Downstream Leased Assets",
          label: "5.2 Downstream Leased Assets",
          isDisabled: true,
        },
        {
          key: "End of Life Stage of the Product",
          label: "5.3 End of Life Stage of the Product",
          isDisabled: true,
        },
        { key: "Investments", label: "5.4 Investments", isDisabled: true },
      ],
    },
    {
      label: "Scope 3 | Category 6",
      value: "Scope 3 | Category 6",
      scope: "3",
      category: [
        {
          key: "Indirect GHG Emissions from other sources",
          label: "6.1 Indirect GHG Emissions from other sources",
          isDisabled: true,
        },
      ],
    },
    {
      label: "CO₂ Emission From Biomass/Bioenergy",
      value: "CO₂ Emission From Biomass/Bioenergy",
      scope: "biomass",
      category: [
        {
          key: "Stationary Combustion",
          label: "1.1 Stationary Combustion",
          isDisabled: true,
        },
        {
          key: "Mobile Combustion",
          label: "1.2 Mobile Combustion",
          isDisabled: true,
        },
        {
          key: "Upstream Transport and Distribution for Goods",
          label: "3.1 Upstream Transport and Distribution for Goods",
          isDisabled: true,
        },
        {
          key: "Downstream Transport and Distribution for Goods",
          label: "3.2 Downstream Transport and Distribution for Goods",
          isDisabled: true,
        },
      ],
    },
    {
      label: "Emission Removal & Mitigation",
      value: "Emission Removal & Mitigation",
      scope: "EmissionRemovalAndMitigation",
      category: [
        {
          key: "Emission Removal & Mitigation",
          label: "Emission Removal & Mitigation",
          isDisabled: false,
        },
      ],
    },
  ],
  category: {
    "1.1 Stationary Combustion": "cat1_1",
    "1.2 Mobile Combustion": "cat1_2",
    "1.3 Industrial Processes": "cat1_3",
    "1.4 Fugitive Emissions": "cat1_4",
    "1.5 Land Use, Land Use Change and Forestry (LULUCF)": "cat1_5",
    "2.1 Imported Electricity": "cat2_1",
    "2.2 Imported Energy": "cat2_2",
    "3.1 Upstream Transport and Distribution for Goods": "cat3_1",
    "3.2 Downstream Transport and Distribution for Goods": "cat3_2",
    "3.3 Employee Commuting": "cat3_3",
    "3.4 Client and Visitor Transport": "cat3_4",
    "3.5 Business Travel": "cat3_5",
    "4.1 Goods Purchased by an Organization": "cat4_1",
    "4.2 Capital Goods that are Purchased and Amortized by an Organization":
      "cat4_2",
    "4.3 Disposal Services (of solid or liquid waste) Used by an Organization":
      "cat4_3",
    "4.4 Use of Assets (through leased equipment) by an Organization": "cat4_4",
    "4.5 Use of Services not Described in the above sub-categories by an Organization":
      "cat4_5",
    "5.1 Use Stage of the Product": "cat5_1",
    "5.2 Downstream Leased Assets": "cat5_2",
    "5.3 End of Life Stage of the Product": "cat5_3",
    "5.4 Investments": "cat5_4",
    "6.1 Indirect GHG Emissions from other sources": "cat6_1",
    "Emission Removal & Mitigation": "rm",
  },
  shippingMethod: {
    0: [
      {
        label: "陸運",
        quantificationMethod: "landQuantificationMethod",
        emissionFactor: "landEmissionFactor",
        emissionSource: "landEmissionSource",
        emissionFactorName: "landEmissionFactorName",
      },
    ],
    1: [
      {
        label: "海運",
        quantificationMethod: "seaQuantificationMethod",
        emissionFactor: "seaEmissionFactor",
        emissionSource: "seaEmissionSource",
        emissionFactorName: "seaEmissionFactorName",
      },
    ],
    2: [
      {
        label: "空運",
        quantificationMethod: "airQuantificationMethod",
        emissionFactor: "airEmissionFactor",
        emissionSource: "airEmissionSource",
        emissionFactorName: "airEmissionFactorName",
      },
    ],
    3: [
      {
        label: "陸運",
        quantificationMethod: "landQuantificationMethod",
        emissionFactor: "landEmissionFactor",
        emissionSource: "landEmissionSource",
        emissionFactorName: "landEmissionFactorName",
      },
      {
        label: "海運",
        quantificationMethod: "seaQuantificationMethod",
        emissionFactor: "seaEmissionFactor",
        emissionSource: "seaEmissionSource",
        emissionFactorName: "seaEmissionFactorName",
      },
    ],
    4: [
      {
        label: "陸運",
        quantificationMethod: "landQuantificationMethod",
        emissionFactor: "landEmissionFactor",
        emissionSource: "landEmissionSource",
        emissionFactorName: "landEmissionFactorName",
      },
      {
        label: "海運",
        quantificationMethod: "seaQuantificationMethod",
        emissionFactor: "seaEmissionFactor",
        emissionSource: "seaEmissionSource",
        emissionFactorName: "seaEmissionFactorName",
      },
    ],
  },
};
